import React from 'react';

import { Menu, Tooltip } from 'antd';
import { STATUS_REQUERIMENTO } from 'utils/consts';

export const ButtonDropdownFinalizar = ({ funcHandleIsValid, funcHandleFinalizar }) => {
  return (
    <Menu>
      <Menu.Item
        key="Solicitacao_Atendida"
        onClick={() => funcHandleIsValid(funcHandleFinalizar, STATUS_REQUERIMENTO.SOLICITACAO_ATENDIDA)}
      >
        <Tooltip placement="left" title="O requerimento foi atendido.">
          Solicitação Atendida
        </Tooltip>
      </Menu.Item>
      <Menu.Item
        key="Processo_Gerado"
        onClick={() => funcHandleIsValid(funcHandleFinalizar, STATUS_REQUERIMENTO.FINALIZADO_PROCESSO_GERADO)}
      >
        <Tooltip placement="left" title="O requerimento finalizado e foi gerado um processo administrativo.">
          Finalizado - Processo Gerado
        </Tooltip>
      </Menu.Item>
      <Menu.Item
        key="Deferido"
        onClick={() => funcHandleIsValid(funcHandleFinalizar, STATUS_REQUERIMENTO.FINALIZADO_DEFERIDO)}
      >
        <Tooltip placement="left" title="O requerimento finalizado e a solicitação atendida.">
          Finalizado Deferido
        </Tooltip>
      </Menu.Item>
      <Menu.Item
        key="Indeferido"
        onClick={() => funcHandleIsValid(funcHandleFinalizar, STATUS_REQUERIMENTO.FINALIZADO_INDEFERIDO)}
      >
        <Tooltip placement="left" title="O requerimento finalizado e houve alguma pendência.">
          Finalizado Indeferido
        </Tooltip>
      </Menu.Item>
    </Menu>
  );
};

export default ButtonDropdownFinalizar;
